/* eslint-disable react/prop-types */
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Breadcrumb } from "antd";
import moment from "moment";
import YoutubeAnalyticsView from "./YoutubeAnalyticsView";
import {
  YOUTUBE_ANALYTICS_MOCK_BINDING,
  YOUTUBE_ANALYTICS_MOCK_ALL_ROWS,
  dateBoundsForCalendarMonth,
  filterYoutubeAnalyticsEstimatesByRange,
} from "./mockData";

const EMPTY_MOCK = "No mock rows for this month — pick a different month.";

const MOCK_TITLE = "Sample film (UI mock)";

export default function YoutubeAnalyticsMockContainer() {
  const [selectedMonth, setSelectedMonth] = useState(() =>
    moment().startOf("month")
  );

  const estimates = useMemo(() => {
    const bounds = dateBoundsForCalendarMonth(selectedMonth);
    if (!bounds) return [];
    return filterYoutubeAnalyticsEstimatesByRange(
      YOUTUBE_ANALYTICS_MOCK_ALL_ROWS,
      bounds
    );
  }, [selectedMonth]);

  const breadcrumbSlot = (
    <>
      <Breadcrumb.Item>
        <Link to="/demo">Demo</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>{MOCK_TITLE}</Breadcrumb.Item>
      <Breadcrumb.Item>YouTube revenue (estimates)</Breadcrumb.Item>
    </>
  );

  const noticeSlot = (
    <Alert
      type="warning"
      showIcon
      closable
      style={{ marginBottom: 16 }}
      message="Local UI preview only"
      description="Dummy data — no login, Firebase, or API. Route: /dev/youtube-analytics-mock. Use the month filter to browse mock history."
    />
  );

  const handleSelectedMonthChange = (m) => {
    if (m && m.isValid()) setSelectedMonth(m.clone().startOf("month"));
  };

  return (
    <YoutubeAnalyticsView
      loadingProject={false}
      isLive
      breadcrumbSlot={breadcrumbSlot}
      backHref="/demo"
      noticeSlot={noticeSlot}
      binding={YOUTUBE_ANALYTICS_MOCK_BINDING}
      chartAreaLoading={false}
      error={null}
      selectedMonth={selectedMonth}
      onSelectedMonthChange={handleSelectedMonthChange}
      estimates={estimates}
      emptyEstimatesDescription={EMPTY_MOCK}
    />
  );
}
